import SideBarTile from './SideBarTile';

export default SideBarTile;